import { skipToken } from "@reduxjs/toolkit/query";

import { useEarnPortfolioSummaryQuery } from "../../reducers/earnVaultApi";
import { EarnPortfolioSummaryPosition } from "../../types";

export function useEarnPortfolioSummaryDomain(wallet: string | undefined): {
    data: EarnPortfolioSummaryPosition[] | undefined;
    isLoading: boolean;
    isFetching: boolean;
} {
    const query = useEarnPortfolioSummaryQuery(wallet ? { wallet } : skipToken);
    return {
        data: query.data,
        isLoading: query.isLoading,
        isFetching: query.isFetching
    };
}
